var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap");

require("app/theme/IconButton--positive.less");

module.exports = kind(/** @lends  app.ProfilePage.PaymentTableRow.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.PaymentTableRow",

    /**
     * @private
     */
    classes: "app-profile-page-payment-table-row",

    /**
     * @private
     */
    tag: "tr",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        tag:        "td",
        components: [{
            name:    "dateLabel",
            classes: "app-profile-page-payment-table-row__label"
        }, {
            name:    "dateValue",
            classes: "app-profile-page-payment-table-row__value"
        }]
    }, {
        tag:        "td",
        components: [{
            name:    "typeLabel",
            classes: "app-profile-page-payment-table-row__label"
        }, {
            name:    "typeValue",
            classes: "app-profile-page-payment-table-row__value"
        }]
    }, {
        tag:        "td",
        components: [{
            name:    "amountLabel",
            classes: "app-profile-page-payment-table-row__label"
        }, {
            name:    "amountValue",
            classes: "app-profile-page-payment-table-row__value"
        }]
    }, {
        tag:        "td",
        components: [{
            name:    "statusLabel",
            classes: "app-profile-page-payment-table-row__label"
        }, {
            name:    "statusValue",
            classes: "app-profile-page-payment-table-row__value"
        }]
    }, {
        tag:        "td",
        components: [{
            name:    "invoiceLabel",
            classes: "app-profile-page-payment-table-row__label"
        }, {
            classes:    "app-profile-page-payment-table-row__value",
            components: [{
                name:    "downloadButton",
                kind:    IconButton,
                classes: "app-profile-page-payment-table-row__download-button",
                mixins:  [HyperLinkSupport],
                ontap:   "onHyperlinkTap",
                theme:   "positive",
                icon:    icons["app.ProfilePage.PaymentTableRow.downloadButton"],
                target:  "_blank"
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService     = this.app.$.i18nService,
            data            = this.data || {},
            $downloadButton = this.$.downloadButton,
            paymentDate     = get(data, "order.inserted_at", null),
            currencyCode    = get(data, "payment.currency_code", null) || "",
            paymentAmount   = get(data, "payment.amount", null),
            invoiceUrl      = get(data, "invoice_url", null),
            $typeValue      = this.$.typeValue;

        // Labels
        this.$.dateLabel.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentDateHeader"));
        this.$.typeLabel.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentTypeHeader"));
        this.$.amountLabel.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentAmountHeader"));
        this.$.statusLabel.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentStatusHeader"));
        this.$.invoiceLabel.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentInvoiceHeader"));

        // Values
        this.$.dateValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.date", {
            date: paymentDate ? new Date(paymentDate) : null
        }));

        switch (get(data, "payment.type", null)) {
            case "change": // Change of payment method
                $typeValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.PaymentType.changePayment"));
                break;
            case "initial": // Brand new subscription
                $typeValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.PaymentType.initial", {
                    offer: (get(data, "offer.name", null) || "").replaceAll("-", "_")
                }));
                break;
            case "subscription": // Recurring subscription payment
            case "extension": // Fallback to default subscription
            case "unsuspend_once":
            case "unsuspend_resubscribe":
            case "unsuspend_retry":
                $typeValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.PaymentType.subscription", {
                    offer: (get(data, "offer.name", null) || "").replaceAll("-", "_")
                }));
                break;
            case "upgrade": // Upgrade to another subscription
                $typeValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.PaymentType.upgrade", {
                    offer: (get(data, "offer.name", null) || "").replaceAll("-", "_")
                }));
                break;
            case "single": // Pay-per-view, not yet active.
            default:
                break;
        }

        paymentAmount = paymentAmount ? paymentAmount / 100 : paymentAmount;
        this.$.amountValue.set("content", new Intl.NumberFormat(i18nService.get("locale"), {
            style:    "currency",
            currency: currencyCode
        }).format(paymentAmount));

        this.$.statusValue.set("content", i18nService.getString("app.ProfilePage.PaymentTableRow.paymentStatus", {
            status: get(data, "payment.status", null) || ""
        }));

        if (invoiceUrl) {
            $downloadButton.set("caption", i18nService.getString("app.ProfilePage.PaymentTableRow.DownloadButton.caption"));
            $downloadButton.set("tooltip", i18nService.getString("app.ProfilePage.PaymentTableRow.DownloadButton.tooltip"));
            $downloadButton.set("href", invoiceUrl);
            $downloadButton.setAttribute("download", "invoice-" + get(data, "payment.id", null) || "");
            $downloadButton.show();
        }
        else {
            $downloadButton.set("caption", "");
            $downloadButton.set("tooltip", "");
            $downloadButton.set("href", null);
            $downloadButton.setAttribute("download", null);
            $downloadButton.hide();
        }
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
